<template>
  <div>
    <div class="featured-content__title">Featured content</div>
    <div 
v-if="hasFeaturedContent" class="featured-content__articles">
      <featured-article
        v-for="article in articles"
        :key="article.url"
        :image="article.image"
        :text="article.text"
        :title="article.title"
        :url="article.url"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import FeaturedArticle from "CivicActionCenterComponents/sections/Home/FeaturedContent/FeaturedArticle.vue";

import STATE from "Constants/campaign/civicactioncenter/state";

export default {
  name: "FeaturedContent",
  components: {
    FeaturedArticle
  },
  computed: {
    ...mapGetters(STATE.SCOPE_CAMPAIGN, {
      hasFeaturedContent: STATE.HAS_FEATURED_CONTENT
    }),
    ...mapState(STATE.SCOPE_CAMPAIGN, {
      articles: STATE.FEATURED_CONTENT
    })
  }
};
</script>
